import React from 'react';
import { Button, Stack } from '@mui/material';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

function OrganizationListPageActions() {
  const { navigateCreate } = useGuardedNavigation('organizations');

  return (
    <Stack direction="row" spacing={1}>
      <Button
        id="create-organization"
        key="add-new-organization"
        variant="contained"
        color="primary"
        onClick={navigateCreate}
      >
        + Create New Organization
      </Button>
    </Stack>
  );
}

export default OrganizationListPageActions;
